export const API_BASE = import.meta.env.VITE_API_URL || '';

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

type ApiErrorBody = {
  error?: string;
  code?: string;
  details?: unknown;
  [key: string]: unknown;
};

export class ApiError extends Error {
  status: number;
  code?: string;
  details?: unknown;
  body?: ApiErrorBody;

  constructor(message: string, input: { status: number; code?: string; details?: unknown; body?: ApiErrorBody }) {
    super(message);
    this.name = 'ApiError';
    this.status = input.status;
    this.code = input.code;
    this.details = input.details;
    this.body = input.body;
  }
}

export async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (!headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  const res = await fetch(apiUrl(path), { ...options, headers, credentials: 'include' });
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: 'Request failed' })) as ApiErrorBody;
    throw new ApiError(body.error || `HTTP ${res.status}`, {
      status: res.status,
      code: body.code,
      details: body.details,
      body,
    });
  }
  const text = await res.text();
  return (text ? JSON.parse(text) : undefined) as T;
}
